// Demo tour stops — press the number key (1-9) on the map to jump to a stop.
// Each stop flies the viewport and switches ON the listed layers (additive —
// it never turns layers off, so the presenter stays in control).
//
// Edit freely before a demo: layerIds are the layer-control ids visible in
// the QA bridge (window.__geomorphicMapQa.getState().layers). All stops below
// assume the Finland (GTK) project is active.

export type DemoTourStop = {
  key: string;          // keyboard digit that triggers the stop
  title: string;        // shown briefly in the overlay chip
  projectId?: string;   // project to activate first (layer ids only exist within their project)
  lon: number;
  lat: number;
  zoom: number;
  layerIds: string[];   // layer-control ids to switch ON
};

export const DEMO_TOUR_STOPS: DemoTourStop[] = [
  {
    key: '1',
    projectId: 'project-gtk-finland',
    title: 'Finland — every drilled cluster, reviewed',
    lon: 26.0,
    lat: 64.8,
    zoom: 5.3,
    layerIds: ['finland:drill-clusters'],
  },
  {
    key: '2',
    projectId: 'project-gtk-finland',
    title: 'Huittinen district — Rita 1 + Rita 2 filed ground',
    lon: 22.80,
    lat: 61.086,
    zoom: 11.3,
    layerIds: ['finland:drill-clusters', 'finland:reservations', 'geojson:fi-ritakallionmaa-va0029', 'geojson:fi-ritakallio-option-f-final'],
  },
  {
    key: '3',
    projectId: 'project-gtk-finland',
    title: 'PALOKALLIO — click the dot, run Morph',
    lon: 22.89575,
    lat: 61.121282,
    zoom: 13.2,
    layerIds: ['finland:drill-clusters'],
  },
  {
    key: '4',
    projectId: 'project-gtk-finland',
    title: 'Sirkka corridor — Levijärvi open island',
    lon: 24.92458,
    lat: 67.81361,
    zoom: 10.5,
    layerIds: ['finland:drill-clusters', 'finland:reservations'],
  },
  {
    key: '5',
    projectId: 'project-gtk-finland',
    title: 'Pora — current TUKES ground + evidence',
    lon: 24.282,
    lat: 63.157,
    zoom: 10.2,
    layerIds: [
      'finland:reservations',
      'geojson:fi-raahe-ladoga-core-ml',
      'geojson:fi-pora-north-varaus',
      'geojson:fi-pora-district-extension',
      'geojson:fi-pora-boulders-float',
      'geojson:fi-pora-visible-gold',
    ],
  },
];
